import { Fragment } from 'react';
import {
  LeaderboardPerson,
  LeaderboardType,
} from '@features/landing/grandprix/typings';
import styles from './LeadersModalList.module.css';
import { cx } from '@libs/classnames';
import { Loader } from '@ui/components/Loader';

type Props = {
  leaders: LeaderboardPerson[];
  isLoading: boolean;
  leaderboardType: LeaderboardType;
};

export function LeadersModalList({
  leaders,
  isLoading,
  leaderboardType,
}: Props) {
  if (isLoading) {
    return <Loader centered />;
  }

  if (!leaders.length) {
    return (
      <div className={styles.empty}>
        {leaderboardType === 'girls'
          ? 'Ни одна участница не найдена'
          : 'Ни один участник не найден'}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <div className={styles.header}></div>
        <div className={styles.header}>Имя</div>
        <div className={cx(styles.header, styles.right)}>Баллы</div>
      </div>
      <div className={styles.content}>
        {leaders.map((l, idx) => (
          <Fragment key={idx}>
            <div className={styles.value}>{l.number}</div>
            <div className={styles.value}>
              {l.firstName} {l.lastName}
            </div>
            <div className={cx(styles.value, styles.right)}>{l.score}</div>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
